(function (ws) {
    'use strict';
    ws.views.shoppingCart = ws.views.cartTable.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'order_activity',
        GTM_EVENT_ACTION: 'save_cart',

        events: _.extend({}, ws.views.cartTable.prototype.events, {
            'click .crt-add-to-cart': 'addToCart',
            'click .qut-cancel-link': 'confirmCancel',
            'click .crt-request-rfq': 'confirmRFQRequest',
            'click .crt-save-cart': 'confirmSaveCart',
            'click .qut-notes': 'showTooltip',
            'click .qup-save': 'saveQuote',
            'click .crt-next-button': 'checkInactiveVendorProducts',
            'mouseover .comp-tooltip-label': 'openTooltip',
            'mouseout .comp-tooltip-label': 'closeTooltip',
            'touchstart .comp-tooltip-label': 'openTooltip',
            'touchend .comp-tooltip-label': 'closeTooltip'

        }),

        /**
         * Extend default initialize function
         */
        initialize: function () {
            // TODO - Move this to its own modal component
            $('.crt-save-cart-btn').on('click', this.saveCart.bind(this));
            this.$table = $('#comp-cart-table');
            this.$clearModal = this.$('.crt-clear-confirm');

            this.apiUrl = globals.path.api.westcon.cartLoadData;
            this.saveUrl = globals.path.api.westcon.shoppingCartSaveUrl;
            this.clearQuoteUrl = globals.path.api.westcon.cartClearAll;
            this.cartPage = true;

            ws.views.cartTable.prototype.initialize.call(this);

            //delete product
            this.$deleteProductModal = this.$('.crt-delete-prod-confirm');
            this.$deleteProduct = this.$deleteProductModal.find('.crt-delete-prod');
            this.deleteProductModalId = this.$deleteProductModal.attr('id');
            this.eventAgg.on(this.deleteProductModalId + 'continue', this.removeProduct, this);

            //add products
            this.addProductsModalId = this.$('.crt-add-prod-confirm').attr('id');
            this.$addProductsQuickEntry = this.$('.crt-add-products');
            this.$addProductsEmptyError = this.$('.crt-add-items .error-message-exclamation');

            //request RFQ
            this.requestRFQModalId = this.$('.crt-request-rfq-modal').attr('id');
            this.requestRFQForm = this.$('.crt-request-rfq-form');
            this.eventAgg.on(this.requestRFQModalId + 'continue', this.requestRFQ, this);

            //save cart
            this.saveCartModalId = this.$('.crt-save-cart-modal').attr('id'); //this.eventAgg.on(this.saveCartModalId + 'continue', this.saveCart, this);
            this.$cartInput = $('.crt-save-cart-name');
            this.$existingCart = $('.savedCartList');
            this.$saveCartError = $('.crt-save-error');
            this.$saveCartSuccess = $('.crt-save-success');

            //for spinner
            this.$saveButton = this.$('.crt-save-cart-btn');
            this.$addToCartButton = this.$('.crt-add-to-cart');
            this.$nextButton = this.$('.crt-next-button');

            this.$restrictedNumberList = this.$('.numList');
            this.$crtNameEmpty = this.$('.crt-name-empty');
            this.$crtNameUsed = this.$('.crt-name-used');
            this.$gaTrackingId = this.$('#gaTrackingId');
            this.$cartNameBothOptionSelected = this.$('.crt-both-selected');
            this.$cartNameBothOptionSelected.hide();
            this.$ivperrors = this.$('.crt-cart-ivp-errors');
            this.$ivperrorProducts = this.$('.crt-cart-ivp-error-products');

            this.cartCategory = 'cart';
            this.shoppingCartCheck = true;
            this.is3PLOrder = this.$('.is3PLOrder');
            this.$quantityError = this.$('.quantityError');
        },

        checkInactiveVendorProducts: function() {
            this.error = false;

            if (this.is3PLOrder.val() === 'true') {
                _.each(this.$('.qup-qty'), function (row) {
                    let element = $(row).closest('tr');
                    let qtyInput = parseInt(element.find('.qup-qty').val());
                    let availability = parseInt(element.find('.crt-sapavailability').text().trim());

                    if (!_.isNumber(qtyInput) || parseInt(qtyInput) <= 0 || parseInt(qtyInput) > availability || isNaN(qtyInput)) {
                        element.find('.qup-qty').addClass('error');
                        this.$quantityError.show();
                        this.error = true;
                    }
                }.bind(this));
            }

            if (!this.error) {
                this.$quantityError.hide();
                this.$('.qup-qty').removeClass('error');
                const model = new ws.models.inactiveVendorProductsModel();
                model.fetch().done(response => {
                    if (response.inactiveVendorProductMsg)
                    {
                        this.$ivperrorProducts.html(response.inactiveVendorProductMsg);
                        this.$ivperrors.show();
                        this.$table.dataTable().fnClearTable();
                        this.$table.DataTable().destroy();
                        ws.views.cartTable.prototype.initialize.call(this);
                        this.eventAgg.trigger('updateCart');
                    } else {
                        window.location.href = this.$('.qut-next-link').attr('href');
                    }
                });
            }
        },

        /**
         * Override default delete function
         * @param {Object} e
         */
        deleteProduct: function (e) {
            var $el = $(e.currentTarget);
            this.$errors.hide();

            var row = $el.parent();
            var id = $el.data('id');
            var type = $el.data('type');
            var productName = $el.data('name');
            var quantity = $el.data('quantity');
            var price = $el.data('price');
            var brand = $el.data('brand');
            var categories = [];
            var category = $el.data('category').replace(/\W/g, '');
            categories.push(category);

            var variant = $el.data('variant');

            this.$deleteProduct.data('row', row);
            this.$deleteProduct.html($el.data('partno'));
            this.$deleteProduct.data('partno', $el.data('partno'));
            this.$deleteProduct.data('idProduct', id);
            this.$deleteProduct.data('type', type);
            this.$deleteProduct.data('productName', productName);
            this.$deleteProduct.data('quantity', quantity);
            this.$deleteProduct.data('price', price);
            this.$deleteProduct.data('brand', brand);
            this.$deleteProduct.data('category', categories);
            this.$deleteProduct.data('variant', variant);
            this.$deleteProduct.data('gaTrackingId', this.$gaTrackingId.val());
            this.eventAgg.trigger(this.deleteProductModalId);
        },

        /**
         * Parse quick entry and add to cart
         * @param {Object} e
         */
        addToCart: function (e) {
            this.cartAction = 'quick entry';
            this.$saveCartSuccess.hide();
            this.$errors.hide();
            this.$addProductsQuickEntry.removeClass('error');
            this.$addProductsEmptyError.hide();
            var products = this.$addProductsQuickEntry.val().trim();

            if (!products) {
                this.$addProductsQuickEntry.addClass('error');
                this.$addProductsEmptyError.show();
            } else {
                this.addProducts(products);
            }
        },

        /**
         * Confirm RFQ request
         */
        confirmRFQRequest: function () {
            this.eventAgg.trigger(this.requestRFQModalId);
        },

        /**
         * open Tooltip
         */
        openTooltip: function (e) {
            var $el = $(e.target);
            $el.next().show();
            $el.parent().next().show();
        },

        /**
         * close Tooltip
         */
        closeTooltip: function () {
            this.$('.comp-tooltip-content').hide();
        },

        /**
         * Request RFQ
         */
        requestRFQ: function () {
            this.requestRFQForm.submit();
        },

        /**
         * Open save cart modal
         */
        confirmSaveCart: function () {
            this.eventAgg.trigger(this.saveCartModalId);
            this.$cartInput.val('');

            $.ajax({
                url: globals.path.api.westcon.shoppingCartSavedCartNames,
                method: 'GET',
                success: function (result) {
                    if (result.length > 0) {
                        $('.existing-cart-name').show();
                        this.dropdownsTemplate = _.template($('#existingSavedCartLists').html());
                        this.savedCartcontainer = $('.saved-cart-dropdown-container');
                        this.savedCartcontainer.html(this.dropdownsTemplate({data:result}));
                    } else {
                        $('.existing-cart-name').hide();
                    }
                },

                error: function (e) {
                    console.log('error', e);
                }
            });

        },

        /**
         * Save cart
         */
        saveCart: function () {
            this.$saveCartError.find('span').hide();
            const cartName = this.$cartInput.val();
            const existingCartName = $('.savedCartList').val();
            const model = new ws.models.shoppingCartModel();

            if (!cartName && !existingCartName) {
                this.$cartInput.addClass('error');
                this.$saveCartError.show();
                this.$crtNameEmpty.show();
                this.$cartNameBothOptionSelected.hide();
            } else if (cartName && existingCartName) {
                this.$cartNameBothOptionSelected.show();
                this.$saveCartError.hide();
                this.$cartInput.removeClass('error');
            } else {

                //enable Spinner
                this.$saveButton.addClass('spinner-before no-padding').prop('disabled', true);
                if (existingCartName) {
                    model.set('cartName', existingCartName);
                    model.url = globals.path.api.westcon.shoppingCartAmmendCartName;
                } else {
                    model.set('cartName', cartName);
                    model.url = globals.path.api.westcon.shoppingCartSaveCartName;
                }

                model.save()
                    .done(response => {
                        if (response.error) {

                            //disable spinner
                            this.$saveButton.removeClass('spinner-before no-padding').prop('disabled', false);
                            this.$saveCartError.show();
                            this.$crtNameUsed.show();
                        } else {

                            //disable spinner
                            this.$saveButton.removeClass('spinner-before no-padding').prop('disabled', false);
                            this.eventAgg.trigger('saveCart', {
                                savedCartCount: response.savedCartCount ? response.savedCartCount : 0
                            });
                            this.eventAgg.trigger(this.saveCartModalId + 'close');
                            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);
                            _satellite.track('event:saveCart');
                            this.$saveCartSuccess.show();
                        }
                    })
                    .fail(() => {
                        this.$saveButton.removeClass('spinner-before no-padding').prop('disabled', false);
                        this.$apiError.show();
                    });
            }
        },

        /**
         * adobe event trigger
         */
        triggerAdobeEvent: function () {
            _satellite.track('event:cart');
        }
    });

})(westcon);
